export default __webpack_public_path__ + "static/media/Thedoctors.00f8eedd.jpeg";